// extracted by mini-css-extract-plugin
export default {"archive":"styles_archive__0GNXt","icon":"styles_icon__8mEvI"};